import { Model } from 'pinia-orm';
import Company from './Company';
import User from "./User";

export default class Notification extends Model {

    static entity = 'notifications';

    static fields() {
        return {
            id: this.uid(),
            type: this.string(''),
            company_id: this.attr(null),
            data: this.attr({}),
            read_at: this.attr(null),
            notifiable_id: this.attr(null),
            notifiable_type: this.attr(null),
            created_at: this.attr(null),
            company: this.belongsTo(Company, 'company_id'),
            notifiable: this.morphTo([User], 'notifiable_id', 'notifiable_type'),
        }
    }
}
